<template>
  <div>
    <div class="text-end ma-6">
      <v-btn color="primary" @click="dialog = !dialog"> <v-icon left>add</v-icon> Thêm KTKL </v-btn>
    </div>
    <v-card class="ma-6" outlined>
      <v-data-table hide-default-footer :headers="headers" :items="violations">
        <template v-slot:[`item.action`]="{ item }">
          <ViolationActions :selected="item"> </ViolationActions>
        </template>
        <template v-slot:[`item.date`]="{ item }">
          {{ item.date | ddmmyyyy }}
        </template>
        <template v-slot:[`item.student`]="{ item }">
          <CardStudentName :student="item.student" link />
        </template>
        <template v-slot:[`item.type`]="{ item }">
          <v-chip small label :color="getColor(item.type)" dark
            ><span v-if="item.type">
              {{ item.type === 'violation' ? 'Kỷ luật' : item.type === 'commendation' ? 'Khen thưởng' : '' }}
            </span>
          </v-chip>
        </template>
      </v-data-table>
    </v-card>
    <ViolationNewDialog :state="dialog" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ViolationNewDialog from './ViolationNewDialog.vue'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import ViolationActions from '@/views/violation/components/ViolationListActions.vue'

export default {
  data() {
    return {
      dialog: null,
      headers: [
        {
          text: 'Ngày',
          value: 'date',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Họ tên',
          value: 'student',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Mục',
          value: 'type',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Nội dung',
          value: 'description',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Thao tác',
          value: 'action',
          align: 'left',
          sortable: false,
          show: true
        }
      ]
    }
  },
  components: {
    ViolationNewDialog,
    CardStudentName,
    ViolationActions
  },
  methods: {
    getColor(s) {
      if (s === 'violation') return 'orange'
      else return '#46BE8A'
    }
  },
  computed: { ...mapState('ClassNoteDetail', ['slot', 'violations']) }
}
</script>

<style></style>
